 export const FixSkuMediaForm = {
    title: 'Media',
    key: [],
    sections: [
      {
        title: 'Main picture',
        columns: 1,
        fields: [
          {
            type: 'upload',
            label: '375*513px (1:1.368 ratio)',
            requestURI: '/files/fixed-sku-main-picture',
            storageURI: '/storage/fixed-sku-main-picture',
            key: ['mainPicture'],
            pos: {
              col: 1,
              row: 1,
              size: 1,
            },
          },
        ],
      },
      {
        title: 'Other pictures',
        columns: 2,
        fields: [
          {
            //   label: 'Add more pictures or videos',
            type: 'multiupload',
            label: '375*513px (1:1.368 ratio)',
            requestURI: '/files/fixed-sku-other-picture',
            storageURI: '/storage/fixed-sku-other-picture',
            key: ['otherPictures'],
            pos: {
              col: 1,
              row: 2,
              size: 1,
            },
          },
        ],
      },
    ],
  }

  export const FixSkuSizesForm = {
    title: 'Sizes',
    sections: [
      {
        canAdd: true,
        key: ['sizes'],
        addSuffix: 'number',
        columns: 4,
        noDivider: true,
        title: 'Size',
        deleteBtn: { label: 'Delete', style: 'title' },
        addBtn: { label: 'Add size', style: 'primary' },
        fields: [
          {
            label: 'Size English Name',
            key: ['name', 'en'],
            isRequired: true,
            pos: {
              col: 1,
              row: 1,
              size: 1,
            },
          },
          {
            label: 'Size Chinese Name',
            key: ['name', 'zh'],
            hideIfFranchiseStore: true,
            isRequired: true,
            pos: {
              col: 2,
              row: 1,
              size: 1,
            },
          },
          {
            label: 'Size value',
            key: ['value'],
            isRequired: true,
            pos: {
              col: 3,
              row: 1,
              size: 1,
            },
          },
        ],
      },
    ],
  }
  